var map = {
	"./locale-provider/bg_BG.tsx": 969,
	"./locale-provider/ca_ES.tsx": 970,
	"./locale-provider/cs_CZ.tsx": 971,
	"./locale-provider/de_DE.tsx": 972,
	"./locale-provider/en_GB.tsx": 973,
	"./locale-provider/en_US.tsx": 974,
	"./locale-provider/es_ES.tsx": 975,
	"./locale-provider/et_EE.tsx": 976,
	"./locale-provider/fi_FI.tsx": 977,
	"./locale-provider/fr_BE.tsx": 978,
	"./locale-provider/fr_FR.tsx": 979,
	"./locale-provider/it_IT.tsx": 980,
	"./locale-provider/ja_JP.tsx": 981,
	"./locale-provider/ko_KR.tsx": 982,
	"./locale-provider/nl_BE.tsx": 983,
	"./locale-provider/nl_NL.tsx": 984,
	"./locale-provider/pl_PL.tsx": 985,
	"./locale-provider/pt_BR.tsx": 986,
	"./locale-provider/ru_RU.tsx": 987,
	"./locale-provider/sk_SK.tsx": 988,
	"./locale-provider/sv_SE.tsx": 990,
	"./locale-provider/tr_TR.tsx": 991,
	"./locale-provider/vi_VN.tsx": 992,
	"./locale-provider/zh_TW.tsx": 993
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 855;



//////////////////
// WEBPACK FOOTER
// ./components ^\.\/locale-provider\/.+_.+\.tsx$
// module id = 855
// module chunks = 0